import React from "react";
import { Img } from "../../ui/img";
import { SelectBox} from "../../ui/selectbox";

const dropDownOptions = [
  // { label: "Option1", value: "option1" },
  // { label: "Option2", value: "option2" },
  // { label: "Option3", value: "option3" },
];

export default function Header({user}) {
  if (user)
    return (
      <header className="p-5 border-gray-200 border-b border-solid bg-white-A700">
        <div className="w-full mx-auto md:p-5 max-w-[1376px]">
          <div className="flex md:flex-col justify-between items-center gap-5">
            <Img src="/media/images/panel/img_image_3.png" alt="imagethree_one" className="w-[12%] md:w-full md:h-auto object-cover" />
            <div className="flex md:flex-col justify-center w-[16%] md:w-full gap-3">
              <SelectBox
                indicator={<Img src="/media/images/panel/img_arrowdown.svg" alt="arrow-down" />}
                name="username"
                placeholder={user.username}
                options={dropDownOptions}
                className="flex gap-px px-[35px] py-3.5 sm:px-5 text-gray-900_ab text-base border-green-400 border border-solid bg-green-400_0c flex-1 rounded-[24px]"
              />
            </div>
          </div>
        </div>
      </header>
    );
}
